<template>
  <svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.3615 5.72286C19.5994 1.9736 17.4733 0 13.9752 0C10.4756 0 8.3644 1.9746 7.63269 5.72286H3.66434L3.53918 5.72741C2.67202 5.79067 2 6.50611 2 7.36518V30.3577L2.00452 30.4794C2.06744 31.3236 2.77967 32 3.66434 32H23.2448L23.3699 31.9955C24.2371 31.9322 24.9091 31.2167 24.9091 30.3577V28.3525L24.9034 28.2567C24.8544 27.8483 24.4957 27.5313 24.0606 27.5313C23.592 27.5313 23.2121 27.899 23.2121 28.3525V30.3577H3.69697V7.36518H7.40941C7.33482 8.25822 7.32163 9.22903 7.36974 10.2757C7.39057 10.7288 7.78696 11.0798 8.2551 11.0596C8.72324 11.0394 9.08586 10.6558 9.06504 10.2027C9.01696 9.15685 9.02962 8.21192 9.1029 7.36518H18.9032C18.9844 8.21383 19.0055 9.16105 18.9663 10.2096C18.9494 10.6628 19.3153 11.0435 19.7836 11.0599C20.2519 11.0763 20.6453 10.7221 20.6622 10.2689C20.7012 9.22474 20.6799 8.25622 20.5981 7.36518H23.2121V11.462L23.2178 11.5577C23.2668 11.9661 23.6255 12.2831 24.0606 12.2831C24.5292 12.2831 24.9091 11.9155 24.9091 11.462V7.36518L24.9046 7.24349C24.8417 6.39925 24.1294 5.72286 23.2448 5.72286H20.3615ZM18.6434 5.72286C17.9979 2.94802 16.4396 1.64232 13.9752 1.64232C11.5124 1.64232 9.9673 2.94703 9.34754 5.72286H18.6434Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.6792 15.7247C22.1754 15.5827 22.7265 15.4569 23.3295 15.3459C23.7898 15.2611 24.234 15.5535 24.3216 15.9991C24.4092 16.4446 24.107 16.8745 23.6466 16.9592C23.2342 17.0352 22.8637 17.1144 22.533 17.1959L23.2193 18.3786C23.9548 18.3018 24.3666 18.285 24.8194 18.3205C25.7849 18.3961 26.4891 18.7739 26.7164 19.595C27.0115 20.6608 26.5395 21.4912 25.4005 22.1372L25.6489 22.5651C25.8784 22.9605 25.7332 23.4611 25.3246 23.6832C24.9452 23.8894 24.4721 23.783 24.2227 23.4501L24.1693 23.3694L23.8341 22.7917C23.2221 22.9851 22.5211 23.1551 21.7365 23.3045C21.2768 23.392 20.8307 23.1023 20.7402 22.6573C20.6498 22.2123 20.9492 21.7806 21.409 21.693C22.016 21.5775 22.5399 21.456 22.9866 21.3314L22.2928 20.1359L22.1303 20.1541C21.3847 20.2328 20.9759 20.2503 20.5225 20.2158C19.5609 20.1427 18.8591 19.7697 18.6328 18.9526C18.3219 17.8295 18.8483 16.9739 20.0856 16.3326L19.8208 15.8763C19.5913 15.4808 19.7365 14.9803 20.1451 14.7582C20.5245 14.552 20.9976 14.6584 21.247 14.9912L21.3004 15.072L21.6792 15.7247ZM20.9099 17.753C20.3958 18.0186 20.2051 18.286 20.272 18.5275C20.2862 18.5789 20.6025 18.6173 21.3812 18.5651L20.9099 17.753ZM24.1364 19.9588L24.5746 20.7139C24.9818 20.4694 25.1357 20.2311 25.0773 20.0201C25.062 19.9647 24.7906 19.9248 24.1364 19.9588Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30 19.6826C30 15.601 26.5811 12.2921 22.3636 12.2921C18.1462 12.2921 14.7273 15.601 14.7273 19.6826C14.7273 23.7642 18.1462 27.073 22.3636 27.073C26.5811 27.073 30 23.7642 30 19.6826ZM16.4242 19.6826C16.4242 16.508 19.0834 13.9345 22.3636 13.9345C25.6439 13.9345 28.303 16.508 28.303 19.6826C28.303 22.8572 25.6439 25.4307 22.3636 25.4307C19.0834 25.4307 16.4242 22.8572 16.4242 19.6826Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ErrandsIcon',
  props: {
    width: {
      type: Number,
      default: 32,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
